<template>
  <v-app>
    <!-- Main -->
    <v-main class=" main-bg">
      <transition :name="transitionName" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>

    <v-footer app height="60" flat class="footer-container">
    <div class="footer-content">
      <!-- Chap tugma -->
      <v-btn icon color="white" @click="navigateTo('candidates')" :class="{ active: $route.name === 'candidates' }">
        <v-icon>mdi-home-outline</v-icon>
      </v-btn>

      <!-- Floating Action Button (Qo‘shish) -->
      <v-btn
        fab
        large
        color="#9C27B0"
        class="fab-btn"
        @click="navigateTo('add-candidate')"
      >
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>

      <!-- Statistikalar -->

      <!-- Profil -->
      <v-btn icon color="white" @click="navigateTo('profile')" :class="{ active: $route.name === 'profile' }">
        <v-icon>mdi-account-outline</v-icon>
      </v-btn>
    </div>
  </v-footer>
  </v-app>
</template>

<script>
import WebApp from "@twa-dev/sdk";

export default {
  data() {
    return {
      transitionName: "fade",
      telegramUsername: "",
      isDarkTheme: this.$vuetify.theme.dark,
    };
  },
  mounted() {
    this.initializeTelegramWebApp();
    const savedTheme = localStorage.getItem("userTheme");
    if (savedTheme) {
      this.isDarkTheme = savedTheme === "dark";
      this.$vuetify.theme.dark = this.isDarkTheme;
    }
  },
  methods: {
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      this.$vuetify.theme.dark = this.isDarkTheme;
      localStorage.setItem('userTheme', this.isDarkTheme ? 'dark' : 'light');
    },
    initializeTelegramWebApp() {
      try {
        WebApp.ready();
        const userData = WebApp.initDataUnsafe.user || {};
        this.telegramUsername = userData.username || userData.first_name || "Unknown";
      } catch (error) {
        console.error("Telegram Web App init error:", error);
      }
    },
    navigateTo(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>

<style scoped>
.main-bg {
  background: linear-gradient(135deg, #0D0D0D, #1A1A2E, #3C1053);; /* Yoki siz xohlagan pushti: #FFC0CB, #FDA4AF, #FF69B4 */
  min-height: 100vh;
}
/* Block Zoom on Mobile */
html,
body {
  
  touch-action: manipulation;
  -ms-touch-action: manipulation;
  -webkit-user-select: none;
  user-select: none;
  overscroll-behavior: none;
  max-zoom: 1;
  min-zoom: 1;
}
.footer-container {
  background: transparent !important;
  display: flex;
  justify-content: center;
  box-shadow: none;
}

/* Glass Footer Panel */
.footer-content {
  background: rgba(255, 255, 255, 0.15); /* 15% shaffof */
  backdrop-filter: blur(15px); /* Glass effekt */
  -webkit-backdrop-filter: blur(15px);
  width: 92%;
  height: 45px;
  border-radius: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

/* Floating Action Button */
.fab-btn {
  position: absolute;
  top: -28px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  border: 4px solid #ffffff;
  transition: transform 0.3s ease;
}


/* Icon tugmalar */
.v-btn {
  color: rgba(255, 255, 255, 0.6);
}

.v-btn:hover {
  color: #8DAE63;
}

/* Aktiv tugma */
.v-btn.active {
  color: #8DAE63;
}
</style>